export const year = "2022-23";
export const isCurrent = false;

export const coreSlices = [];

export const core = [];

export const teams = [];
